import { useMemo } from 'react';

import { EditingProjectStateErrors } from '../../../types/EditingProjectState';

export const useGetAssetFormErrors = (errors: EditingProjectStateErrors) => {
  return useMemo(() => {
    const emptyErrors: Array<string> = [];
    if (errors == null) return;
    if (Object.keys(errors.assetCategoryValueEmptyErrors).length <= 0) return;
    const keys = Object.keys(errors.assetCategoryValueEmptyErrors);
    Array.from(keys).forEach((key) => {
      const assetCategoryValueEmptyErrors = errors.assetCategoryValueEmptyErrors[key];
      typeof assetCategoryValueEmptyErrors !== 'undefined' &&
        assetCategoryValueEmptyErrors.forEach((error) => {
          !emptyErrors.includes(error.message) && emptyErrors.push(error.message);
        });
    });
    return emptyErrors;
  }, [errors]);
};
